import { render, staticRenderFns } from "./referrals-statistics-card.vue?vue&type=template&id=12cf1bcb&scoped=true&"
import script from "./referrals-statistics-card.vue?vue&type=script&lang=js&"
export * from "./referrals-statistics-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cf1bcb",
  null
  
)

export default component.exports